import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchDataset = () => axios.get(`${API}/dataset`).then((r) => r.data).catch((e) => { if (e.response?.status === 404) return null; throw e; });
export const fetchMeta = () => axios.get(`${API}/dataset/meta`).then((r) => r.data);
export const saveDataset = (body) => axios.put(`${API}/dataset`, body).then((r) => r.data);
export const deleteDataset = () => axios.delete(`${API}/dataset`);
export const fetchHidden = () => axios.get(`${API}/pickers/visibility`).then((r) => r.data.hidden);
export const saveHidden = (hidden) => axios.put(`${API}/pickers/visibility`, { hidden }).then((r) => r.data.hidden);

export const filterRaw = (raw, hidden) => {
  if (!raw || !hidden?.length) return raw;
  const h = new Set(hidden);
  const days = raw.days ? Object.fromEntries(Object.entries(raw.days).filter(([id]) => !h.has(id))) : raw.days;
  return { ...raw, users: raw.users.filter((u) => !h.has(u.id)), days, hiddenCount: raw.users.length - raw.users.filter((u) => !h.has(u.id)).length };
};

export const fetchHolidays = () => axios.get(`${API}/holidays`).then((r) => r.data.items);
export const saveHolidays = (items) => axios.put(`${API}/holidays`, { items }).then((r) => r.data.items);

export const fetchShifts = () => axios.get(`${API}/pickers/shifts`).then((r) => r.data.shifts);
export const saveShifts = (shifts) => axios.put(`${API}/pickers/shifts`, { shifts }).then((r) => r.data.shifts);

export const loadDashboardData = async () => {
  const [data, hidden, holidays, shifts] = await Promise.all([fetchDataset(), fetchHidden().catch(() => []), fetchHolidays().catch(() => []), fetchShifts().catch(() => ({}))]);
  const raw = filterRaw(data, hidden);
  return raw ? { ...raw, holidays: new Set(holidays.map((h) => h.date)), shiftOverrides: shifts } : raw;
};
